import React, { useState } from 'react'
import AuthHeader from '../../components/Navbar/AuthHeader'
import { Link } from 'react-router-dom'
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';
import { useNavigate } from 'react-router-dom';
import { passwordReset } from '../../actions/auth';

function PasswordRecovery() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const publicUrl = process.env.REACT_APP_PUBLIC_URL;

    const handlePassword = async (e) => {
        e.preventDefault();

        if (!email) return; 
        setIsLoading(true); 

        try {
            await passwordReset(email, navigate);
        } catch (error) {
            // console.error("Email verification failed:", error);
        }

        setIsLoading(false);
    };
  return (
    <div style={{background: '#13053A',minHeight: '100vh'}}>
      <AuthHeader />
            <div className="auth__container padding__tb_30">
                <div className='auth__container__box'>
                    <h3>Password Recovery</h3>
                    <p className='auth__text'>Remembered your password? <Link to='/login' className='text-decoration-none'>Login</Link></p>
                    {/* Progress Dots */}
                    <ProgressSteps currentStep={1} totalSteps={3} />
                    <div className='auth__container__form'>
                        <form onSubmit={handlePassword}>
                            <div className='form__group mb-4'>
                                <label htmlFor='email' className='label__form'>Enter your email address  </label>
                                <div className="input-group">
                                    <span className='auth__input__group'><MdOutlineMarkEmailRead /></span>
                                    <input 
                                        type="email" 
                                        id="email"
                                        className='auth__input' 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)} 
                                        required
                                    />
                                </div>
                            </div>
                            <div className='form__group'>
                                <button type='submit' className='btn btn__block'>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : 'Continue'}  
                                </button>
                            </div>
                        </form>
                        {/* <div style={{ paddingTop: '35px'}}>
                            <p className='auth__text__small'>Or sign in using</p>
                        </div>
                        <div className='create__account__social'>
                            <Link className='social__account__box'>
                                <FcGoogle className='social__account__icon' />
                            </Link>
                            <Link className='social__account__box'>
                                <FaFacebook className='social__account__icon' />
                            </Link>
                            <Link className='social__account__box'>
                                <FaApple className='social__account__icon last' />
                            </Link>
                        </div> */}
                        <p className='auth__container__box__text'>By registering you accept our <Link to={`${publicUrl}/legal`}> Terms of use </Link> and <Link to={`${publicUrl}/legal`}> Privacy Policy</Link></p>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default PasswordRecovery;